import type { WixSDKTypes } from '@wix/public-editor-platform-interfaces';
import { ApplicationContext } from '@wix/editor-platform-contexts';
import { getMonitoringClientFunction } from '@wix/monitoring-browser-sdk-host';
import { WorkspaceHost } from './workspaceHost';
import type { Workspace } from './workspaceHost';

declare global {
  interface Window {
    Sentry?: any;
  }
}

export const frame = (): WixSDKTypes.Host & {
  workspace: Workspace;
  applicationContext: Promise<ApplicationContext>;
  essentials: {
    language?: string;
    locale?: string;
  };
} => {
  const queryParams = new URLSearchParams(window.location.search);
  const essentialsQueryParamValue = queryParams.has('essentials')
    ? JSON.parse(queryParams.get('essentials')!)
    : undefined;
  const { monitoring, ...essentials } = essentialsQueryParamValue || {};
  const appDefinitionId = queryParams.get('appDefinitionId')!;
  const { context, config } = monitoring || {};
  const getMonitoringClient = getMonitoringClientFunction({
    hostContext: { appId: appDefinitionId, ...context },
    monitoringConfig: config,
    sentrySDK: typeof window !== 'undefined' ? window.Sentry : undefined,
  });

  const applicationContext = ApplicationContext.getInstance();
  const workspaceHost = new WorkspaceHost(applicationContext);

  return {
    environment: {},
    applicationContext,
    channel: {
      observeState: async () => {
        return { disconnect() {} };
      },
    },
    getMonitoringClient,
    workspace: workspaceHost.getAPI(),
    essentials,
  };
};

export const worker = (): WixSDKTypes.Host & {
  workspace: Workspace;
  applicationContext: Promise<ApplicationContext>;
} => {
  const applicationContext = ApplicationContext.getInstance();
  const workspaceHost = new WorkspaceHost(applicationContext);

  return {
    environment: {},
    applicationContext,
    channel: {
      observeState: async () => {
        return { disconnect() {} };
      },
    },
    workspace: workspaceHost.getAPI(),
  };
};
